import FJActionConstant from "../../constant/FJActionConstant";
import FJViewConstant from "../../constant/FJViewConstant";
import FJConfig from "../../config/FJConfig";
import FJCoreConstant from "../../core/constant/FJCoreConstant";

const initState = {
  watermarkType: FJCoreConstant.WATERMARK_TEXT,
	watermarkText: '',
  watermarkTextColor: '#FFFFFF',
	watermarkFontFamily: FJConfig.fontFamily,
	watermarkSize: 100,
	watermarkOpacity: 50,
	watermarkPosition: FJCoreConstant.LEFT_TOP,
  watermarkImageStatus: FJViewConstant.MEDIA_STATUS_LOADING,
  watermarkImageProgress: 0,
  watermarkImageUrl: '',
	isExistWaterImage: false,
}

export default function (state = initState, action) {
	switch (action.type) {
    case FJActionConstant.SET_WATERMARK_TYPE:
      return {
        ...state,
        watermarkType: action.watermarkType,
      }
    case FJActionConstant.SET_WATERMARK_TEXT_VALUE:
      return  {
        ...state,
        watermarkText: action.watermarkText,
      }
    case FJActionConstant.SET_WATERMARK_TEXT_COLOR:
      return  {
        ...state,
        watermarkTextColor: action.color,
      }
		case FJActionConstant.SET_WATERMARK_FONT_FAMILY:
			return {
				...state,
        watermarkFontFamily: action.watermarkFontFamily,
			}
		case FJActionConstant.SET_WATERMARK_SIZE:
			return {
				...state,
				watermarkSize: action.watermarkSize
			}
		case FJActionConstant.SET_WATERMARK_OPACITY:
			return {
				...state,
				watermarkOpacity: action.watermarkOpacity
			}
		case FJActionConstant.SET_WATERMARK_POSITION:
			return {
				...state,
				watermarkPosition: action.watermarkPosition
			}
    case FJActionConstant.SET_WATERMARK_PROGRESS:
      return {
        ...state,
        watermarkImageProgress: action.progress,
      }
    case FJActionConstant.SET_WATERMARK_STATUS:
      return {
        ...state,
        watermarkImageStatus: action.status,
      }
    case FJActionConstant.SET_WATERMARK_URL:
      return {
        ...state,
        watermarkImageUrl: action.url,
      }
		case FJActionConstant.SET_WATERMARK_IMAGE_IS_EXIST:
			return {
				...state,
				isExistWaterImage: action.isExist
			}
		default:
			return state;
	}
}

